/*
 * Notes and notebooks. The front-end manifest, see lib/docs/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'notes',
	locale: { de, en },
});
